(function () {
	const audio = document.querySelector('audio');
	const lyrics = document.querySelector('#lyrics');
	const lines = lyrics?.querySelectorAll<HTMLSpanElement>('span[data-times]');

	if (!audio || !lyrics || !lines) {
		return;
	}

	audio.addEventListener('timeupdate', function () {
		const {currentTime} = audio;

		for (const line of lines) {
			const timesString = line.dataset.times;
			const times = timesString
				?.split(',')
				.map((t) => Number.parseFloat(t.trim()));
			const duration = Number.parseFloat(line.dataset.duration ?? '0');

			if (times) {
				let isActive = false;
				for (const startTime of times) {
					const endTime = startTime + duration;

					if (currentTime >= startTime && currentTime < endTime) {
						isActive = true;
						break;
					}
				}

				if (isActive) {
					line.classList.add('active');
				} else {
					line.classList.remove('active');
				}
			}
		}
	});

	// Click or press Enter/Space to jump to line times
	const jumpTo = async (line: HTMLSpanElement) => {
		const times = line.dataset.times
			?.split(',')
			.map((t) => Number.parseFloat(t.trim()));
		if (times) {
			audio.currentTime = times[0];
			await audio.play();
		}
	};

	for (const line of lines) {
		line.tabIndex = 0;
		line.setAttribute('role', 'button');

		line.addEventListener('click', async () => {
			await jumpTo(line);
		});

		line.addEventListener('keydown', async (event) => {
			if (event.key === 'Enter' || event.key === ' ') {
				event.preventDefault();
				await jumpTo(line);
			}
		});
	}
})();
